<div id="load_screen" *ngIf="active">
    <div class="loader">
        <div class="loader-content">
            <div class="text-primary align-self-center loader-lg">
                <img src="assets/assets/img/Cipherpay loader.gif" style="height:100px ;width: 100px;">
            </div>
        </div>
    </div>
</div>
